import React, { useRef } from "react";
import styled from "styled-components";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay, EffectFade } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/effect-fade";
import { Link } from "react-router-dom";

const bannerData = [
  {
    id: 1,
    bg: "/assets/images/bg/banner-bg-01.png",
    title: (
      <>
        Leader in industrial Factory around <br />
        the world
      </>
    ),
    description:
      "We face each project as Link new challenge and with our ability to build and innovate we overcome all barriers.",
    video: "https://www.youtube.com/watch?v=Yue48fUXuqI",
  },
  {
    id: 2,
    bg: "/assets/images/bg/banner-bg-02.png",
    title: (
      <>
        Moving Your Industry Manufacturing <br />
        Forward
      </>
    ),
    description:
      "We face each project as Link new challenge and with our ability to build and innovate we overcome all barriers.",
    video: "https://www.youtube.com/watch?v=Yue48fUXuqI",
  },
];

const Banner = () => {
  const prevRef = useRef(null);
  const nextRef = useRef(null);

  return (
    <Wrapper>
      <section className="rs-banner-area rs-banner-one p-relative">
        {/* <div className="rs-banner-shape">
          <img src="/assets/images/shape/half-arrow.png" alt="shape" />
        </div> */}

        <div className="container">
          <div className="row align-items-center g-5">
            <div className="col-xl-2">
              <div className="rs-banner-meta-wrapper">
                <div className="rs-banner-contact-item">
                  <span>Email.</span>
                  <h6>
                    <Link to="mailto:infoequegroup@gmail.com">
                      infoequegroup@gmail.com
                    </Link>
                  </h6>
                </div>
                <div className="rs-banner-contact-item">
                  <span>Call.</span>
                  <h6>
                    <Link to="tel:01833688844">01833688844</Link>
                  </h6>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="rs-banner-slider-wrapper">
          <Swiper
            modules={[Navigation, Pagination, Autoplay, EffectFade]}
            slidesPerView={1}
            loop={true}
            speed={2000}
            effect="fade"
            autoplay={{
              delay: 1000,
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
            }}
            onBeforeInit={(swiper) => {
              swiper.params.navigation.prevEl = prevRef.current;
              swiper.params.navigation.nextEl = nextRef.current;
            }}
            navigation={{
              prevEl: prevRef.current,
              nextEl: nextRef.current,
            }}
            pagination={{
              el: ".swiper-pagination",
              clickable: true,
            }}
            className="rs-swiper"
          >
            {bannerData.map((item) => (
              <SwiperSlide key={item.id}>
                <div className="rs-banner-item-wrapper">
                  <div
                    className="rs-banner-bg-thumb"
                    style={{
                      backgroundImage: `url(${item.bg})`,
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                      backgroundRepeat: "no-repeat",
                    }}
                  ></div>

                  <div className="container">
                    <div className="row">
                      <div className="col-xxl-8 col-xl-8 col-lg-10">
                        <div className="rs-banner-item">
                          <div className="rs-banner-content">
                            <h1 className="rs-banner-title">{item.title}</h1>

                            <div className="rs-banner-descrip">
                              <p>{item.description}</p>
                            </div>

                            <div className="rs-banner-info-btn">
                              <div className="rs-banner-btn">
                                <Link
                                  className="rs-btn has-theme-orange has-icon has-bg"
                                  to="/contact"
                                >
                                  Explore More
                                </Link>
                              </div>

                              <div className="rs-feature-video">
                                <Link
                                  to={item.video}
                                  className="rs-play-btn popup-video"
                                >
                                  <i className="ri-play-fill"></i>
                                </Link>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            ))}

            {/* Navigation Buttons */}
            <div className="rs-banner-navigation">
              <button
                ref={prevRef}
                className="swiper-button-prev rs-swiper-btn mb-3"
              >
                <i className="fa-regular fa-arrow-left"></i>
              </button>
              <button
                ref={nextRef}
                className="swiper-button-next rs-swiper-btn"
              >
                <i className="fa-regular fa-arrow-right"></i>
              </button>
            </div>

            {/* Pagination */}
            <div className="rs-banner-pagination d-block d-md-none">
              <div className="swiper-pagination rs-pagination has-theme-orange"></div>
            </div>
          </Swiper>
        </div>
      </section>
    </Wrapper>
  );
};

const Wrapper = styled.section`
  .swiper-button-prev svg,
  .swiper-button-next svg {
    display: none !important;
  }

  .fa-arrow-left:before,
  .fa-arrow-right:before {
    color: #fff !important; /* White arrows */
    font-size: 20px;
  }

  /* Navigation buttons wrapper */
  .rs-banner-navigation {
    display: flex;
    align-items: center;
    gap: 20px; /* 20px gap between prev & next buttons */
  }
`;

export default Banner;
